/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_How_Heard_LongInputs */

const en_us2_intake_why_how_heard_long = /** @type {(inputs: Intake_Why_How_Heard_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It helps us understand how people find the app. It changes no set, load or recommendation, and you can skip it.`)
};

const pt_br2_intake_why_how_heard_long = /** @type {(inputs: Intake_Why_How_Heard_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuda a gente a entender por onde as pessoas chegam até o app. Não muda nenhuma série, carga ou recomendação, e você pode pular.`)
};

const es_419_intake_why_how_heard_long = /** @type {(inputs: Intake_Why_How_Heard_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos ayuda a entender cómo llegan las personas a la app. No cambia ninguna serie, carga ni recomendación, y puedes saltarla.`)
};

const pt_pt2_intake_why_how_heard_long = /** @type {(inputs: Intake_Why_How_Heard_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuda-nos a perceber como as pessoas chegam à app. Não muda nenhuma série, carga ou recomendação, e podes saltar esta pergunta.`)
};

const fr_fr2_intake_why_how_heard_long = /** @type {(inputs: Intake_Why_How_Heard_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça nous aide à comprendre comment les gens découvrent l'app. Ça ne change aucune série, charge ou recommandation, et tu peux passer.`)
};

const de_de2_intake_why_how_heard_long = /** @type {(inputs: Intake_Why_How_Heard_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hilft uns zu verstehen, wie Leute die App finden. Es ändert keinen Satz, kein Gewicht und keine Empfehlung, und du kannst es überspringen.`)
};

const it_it2_intake_why_how_heard_long = /** @type {(inputs: Intake_Why_How_Heard_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci aiuta a capire come le persone arrivano all'app. Non cambia nessuna serie, carico o consiglio, e puoi saltarla.`)
};

/**
* | output |
* | --- |
* | "It helps us understand how people find the app. It changes no set, load or recommendation, and you can skip it." |
*
* @param {Intake_Why_How_Heard_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_how_heard_long = /** @type {((inputs?: Intake_Why_How_Heard_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_How_Heard_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_how_heard_long(inputs)
	if (locale === "es-419") return es_419_intake_why_how_heard_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_how_heard_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_how_heard_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_how_heard_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_how_heard_long(inputs)
	return en_us2_intake_why_how_heard_long(inputs)
});
export { intake_why_how_heard_long as "intake.why.how_heard.long" }